import axios from '@!/lib/axios'
import { buildUrlString } from '@!/Util'

export const bookDetailsApi = async (bookId) => {
  const url = buildUrlString(`/api/v1/store_books.json`, { book_id: bookId })
  return await axios.get(url)
}

export const volumesApi = async (bookTitleId) => {
  const url = buildUrlString(`/api/v1/store_books/volumes.json`, { title_id: bookTitleId })
  return await axios.get(url)
}

export const freeTitlesApi = async (genreTabName, page, fetchType) => {
  const api_path = '/api/v1/store_books/free_titles.json'
  const url = buildUrlString(api_path, { genre_tab_name: genreTabName, page, fetch_type: fetchType })
  return await axios.get(url)
}

export const readContentApi = async ({ contentId }) => {
  const api_path = '/api/v1/users/stores/read_content.json'
  const url = buildUrlString(api_path, { content_id: contentId })
  return await axios.get(url)
}

export const readFreeContentApi = async ({ contentId }) => {
  const api_path = '/api/v1/users/stores/read_free_content.json'
  const url = buildUrlString(api_path, { content_id: contentId })
  return await axios.get(url)
}

export const readContentSampleApi = async ({ contentId }) => {
  const api_path = '/api/v1/users/stores/read_content_sample.json'
  const url = buildUrlString(api_path, { content_id: contentId })
  return await axios.get(url)
}
